module.exports = __webpack_public_path__ + "static/ideaMobile@2x-d47816bb8ea44f0a7ac8facd486a6ba3.png";